import { isMobileDevice } from './device';
import { getRmQrConfig } from '../config/uiConfig';

export const RM_QR_PREFIX = 'IB24';
export const RM_QR_TYPE = 'RM';
export const RM_QR_VERSION = 'v1';

/** Org/tenant segment, e.g. SG-GROUP → IB24|SG-GROUP|RM|v1|... */
export function getRmQrOrgCode(): string {
  return String(getRmQrConfig().orgCode || 'SG-GROUP').trim() || 'SG-GROUP';
}

/**
 * Canonical payload:
 *   IB24|{orgCode}|RM|v1|SKU=...|HEAT=...
 * Also readable by backend when heat omitted.
 */
export function encodeRmQrPayload(sku: string, heatNo?: string | null): string {
  const parts = [RM_QR_PREFIX, getRmQrOrgCode(), RM_QR_TYPE, RM_QR_VERSION];
  if (sku?.trim()) parts.push(`SKU=${sku.trim()}`);
  if (heatNo?.trim()) parts.push(`HEAT=${heatNo.trim()}`);
  return parts.join('|');
}

/**
 * Parse structured IB24 payloads (new org form and legacy IB24|RM|v1|...).
 * Field pairs (SKU=, HEAT=) are collected from any segment that contains `=`.
 */
export function parseRmQrPayload(rawCode: string): {
  rawCode: string;
  orgCode?: string;
  sku?: string;
  heatNo?: string;
} {
  const trimmed = (rawCode || '').trim();
  if (!trimmed) return { rawCode: '' };
  if (!trimmed.toUpperCase().startsWith(`${RM_QR_PREFIX}|`)) {
    return { rawCode: trimmed, sku: trimmed };
  }

  const parts = trimmed.split('|');
  const fields: Record<string, string> = {};
  for (const part of parts) {
    const eq = part.indexOf('=');
    if (eq > 0) {
      fields[part.substring(0, eq).trim().toUpperCase()] = part.substring(eq + 1).trim();
    }
  }

  // New: IB24|ORG|RM|v1|...  Legacy: IB24|RM|v1|...
  let orgCode: string | undefined;
  if (parts.length >= 2) {
    const second = (parts[1] || '').trim();
    if (second.toUpperCase() !== RM_QR_TYPE) {
      orgCode = second;
    }
  }

  return {
    rawCode: trimmed,
    orgCode,
    sku: fields.SKU,
    heatNo: fields.HEAT,
  };
}

/** Prefer this for login / redirect — UA + touch + width (not width-only). */
export function isMobileViewport(): boolean {
  return isMobileDevice();
}
